const styles = theme => ({
  xLabel: {
    marginTop: '15px'
  }
});

export default styles;
